// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"simple-container_wrapper__2syDp"};